import { useTranslation } from 'react-i18next'
import { Tooltip } from 'react-tippy'

import { useTheme } from 'styled-components'

import { Chip, PackageCheckIcon, Switch, Text } from '@reveni-io/reveni-ui'

import { packagingTypeLabels } from '../constants'
import PackagingItemMenu from './PackagingItemMenu/PackagingItemMenu'
import { getPackagingTypeIcon } from './helpers'
import * as Styles from './styles'

const PackagingItem = ({ data, onEdit, onDelete, onDuplicate, onSetDefault, onChangeEnabled, index, isEditable }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  const handleClick = () => {
    if (onEdit) {
      onEdit(data)
    }
  }

  const dimensionsLabel = `${data.length} x ${data.width} x ${data.height} ${data.dimension_unit}`

  const weightLabel = `${data.weight} ${data.weight_unit}`

  const detailText = `${dimensionsLabel} | ${weightLabel}`

  return (
    <Styles.MainContainer
      backgroundColor={index % 2 ? theme.colors.background.secondary : 'white'}
      onClick={handleClick}
    >
      <Styles.IdentifierContainer>
        <Text type="bodyMBold">#{data?.internal_id}</Text>
      </Styles.IdentifierContainer>
      <Styles.InfoContainer>
        <Styles.Header>
          <Styles.NameContainer>
            <Switch
              checked={data?.is_enabled}
              disabled={!isEditable}
              onChange={e => onChangeEnabled(data?.id, e.target.checked)}
              onClick={e => e.stopPropagation()}
            />
            <Styles.Name isEnabled={data?.is_enabled}>
              <Tooltip title={t(packagingTypeLabels[data?.type])} arrow>
                {getPackagingTypeIcon(data?.type, data?.is_enabled, t, theme)}
              </Tooltip>
              <div>
                <Text type="titleS" tag="label">
                  {data?.name}
                </Text>
              </div>
            </Styles.Name>
          </Styles.NameContainer>
          <Styles.Actions>
            {data?.is_default && <Chip Icon={PackageCheckIcon} label={t('Por defecto')} disabled={!data?.is_enabled} />}
            {isEditable && (
              <PackagingItemMenu
                data={data}
                onEdit={onEdit}
                onDelete={onDelete}
                onDuplicate={onDuplicate}
                onSetDefault={onSetDefault}
              />
            )}
          </Styles.Actions>
        </Styles.Header>
        {detailText && (
          <Styles.DetailText isEnabled={data?.is_enabled}>
            <Text type="bodyMRegular">{detailText}</Text>
          </Styles.DetailText>
        )}
      </Styles.InfoContainer>
    </Styles.MainContainer>
  )
}

export default PackagingItem
